function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "10.227",
  height: "16.735"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_1199",
  "data-name": "Path 1199",
  d: "M6.508 8.367L0 1.859 1.859 0l8.367 8.367-8.367 8.368L0 14.876z",
  fill: "#fff"
})));